import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { serverFetch } from '@server';

// Счётчик непрочитанных диалогов для бейджа в меню:
// при монтировании, смене фирмы, каждые 60 с и по событию 'dialogs-changed'
export function useUnreadDialogs() {
    const user = useSelector((s) => s.user);
    const companyId = user?.companyId;
    const [count, setCount] = useState(0);

    const load = useCallback(() => {
        if (companyId == null) {
            setCount(0);
            return;
        }
        serverFetch('dialog/unread-count')
            .then((r) => setCount(r?.count ?? 0))
            .catch(() => {});
    }, [companyId]);

    useEffect(() => {
        load();
        const timer = setInterval(load, 60000);
        window.addEventListener('dialogs-changed', load);
        return () => {
            clearInterval(timer);
            window.removeEventListener('dialogs-changed', load);
        };
    }, [load]);

    return count;
}
